export const COMPANY = {
    name: "CoreCyrus",
    tagline: "Connecting Businesses. Empowering Growth.",
    phone: "+91 93841 64646",
    phoneRaw: "+919384164646",
    whatsapp: "919384164646",
    email: "info@corecyrus.com",
    address: {
        line1: "Srinivasaa Spaces, 252-253, Kandasamy Layout",
        line2: "Pappanaickenpalayam",
        city: "Coimbatore",
        state: "Tamil Nadu",
        zip: "641037",
        country: "India",
    },
    hours: "Mon – Fri • 6:30 PM – 3:30 AM",
};

export const LOGO_URL = "/corecyrus-logo.png";

export const NAV_LINKS = [
    { label: "Home", to: "/", id: "home" },
    { label: "About", to: "/#about", id: "about" },
    { label: "Products", to: "/products", id: "products" },
    { label: "Services", to: "/#services", id: "services" },
    { label: "Industries", to: "/#industries", id: "industries" },
    { label: "Contact", to: "/#contact", id: "contact" },
];

export const waLink = (message = "Hello CoreCyrus, I'd like to request a quote.") =>
    `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(message)}`;
